import {
  createNotesModel,
  TNoteAction,
  TNotesResponseScheme,
  ICreateNotesModelParams,
} from '@cian/api-models/monolith-python/ajax/notes';
import { IHttpApi } from '@cian/http-api/shared';
import { EDealType } from '../repositories/favorites/entities/favorite_entity_for_desktop/FavoriteEntityForDesktopSchema';
import { EFavoriteEntityType } from '../types/filters';

export interface ISaveNoteApiParams {
  oid: number;
  text: string;
  action: TNoteAction;
  csrf_token: string;
}

export interface ISaveNoteParams extends ISaveNoteApiParams {
  offerType: EFavoriteEntityType;
  dealType: EDealType;
  httpApi: IHttpApi;
}

export interface IApiParamsSaveNote extends ISaveNoteParams {
  subdomain: string;
}

export function updateNoteApi(params: IApiParamsSaveNote): Promise<TNotesResponseScheme> {
  const { httpApi, offerType, dealType, subdomain, ...apiParams } = params;
  const createNotesModelParams: ICreateNotesModelParams = {
    offerType,
    dealType,
    config: { parameters: { ...prepareParams(apiParams) } },
  };

  return httpApi.fetch(createNotesModel(createNotesModelParams), {
    requestConfig: {
      headers: [['Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8']],
      withCredentials: true,
    },
    subdomain,
    bodyAsEncodeString: true,
  });
}

export function prepareParams({ oid, ...rest }: ISaveNoteApiParams) {
  return { oid: oid.toString(), ...rest };
}
